export default __webpack_public_path__ + "static/media/pageBg.2a245ad4.png";